import { createSelector } from 'reselect';

const selectAccessControls = (state: any) => state.accessControls;


export const selectCurrentItem = createSelector([selectAccessControls], (accessControls) => accessControls.current);

export const selectListItems = createSelector([selectAccessControls], (accessControls) => accessControls.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCreatedItem = createSelector([selectAccessControls], (accessControls) => accessControls.create);

export const selectUpdatedItem = createSelector([selectAccessControls], (accessControls) => accessControls.update);

export const selectReadItem = createSelector([selectAccessControls], (accessControls) => accessControls.read);

export const selectDeletedItem = createSelector([selectAccessControls], (accessControls) => accessControls.delete);

export const selectSearchedItems = createSelector([selectAccessControls], (accessControls) => accessControls.search);

export const selectItemsCount = createSelector([selectAccessControls], (accessControls) => accessControls.count);

export const selectItemsFilter = createSelector([selectAccessControls], (accessControls) => accessControls.filter);